import React from 'react'
import { useSelector } from 'react-redux'
import { IReducer } from './interface'
import { IntlNavigate } from './components/Common/IntlComponents'

export default function ProtectedRoute(props: any) {
  const accountReducer = useSelector((state: IReducer) => state.accountReducer)
  const { isAuthenticated } = accountReducer
  if (!isAuthenticated) {
    return <IntlNavigate to={'/login'} replace />
  }
  return props.children
}
